module.exports = __webpack_public_path__ + "img/Revolution@2x.57568318.png";